import { render, staticRenderFns } from "./TableStructures.vue?vue&type=template&id=37fcdfd8"
import script from "./TableStructures.vue?vue&type=script&lang=js"
export * from "./TableStructures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports